import { api } from "../app/api.js";
import { store } from "../app/store.js";
import { display_errors } from "../helpers/forms.js";

export default {
    template: `
        <div class="background posters"></div>
        <div class="flexy-column">
            <div class="container">
                <h1>Log In</h1>
        
                <form id="login-form" class="form">
                    <div class="input">
                        <label for="LoginEmailAddress">Email Address</label>
                        <input type="text" id="LoginEmailAddress" name="email" autocomplete="off"/>
                    </div>
        
                    <div class="input">
                        <label for="LoginPassword">Password</label>
                        <input type="password" name="password" id="LoginPassword" />
                    </div>
                    
                    <div class="input checkbox">
                        <input type="checkbox" id="LoginRemember" name="remember_me"/>
                        <label for="LoginRemember">Remember me</label>
                    </div>
        
                    <button id="LoginSubmit" type="submit">Log In</button>
                    <div id="LoginErrors" class="errors hidden"></div>
                </form>
        
                <p class="center"><a href="/forgotten_password" class="highlight">Forgotten password?</a><br/>
                <a id="RegisterLink" href="/register" class="highlight">Don't have an account? Register Now!</a></p>
        
            </div>
        </div>
    `,

    $form: null,
    $errors: null,
    $submit: null,

    submit (event) {
        event.preventDefault();

        this.$submit.disabled = true;
        this.$submit.textContent = 'Signing in...';
        this.$errors.textContent = '';
        this.$errors.classList.add('hidden');

        api.post({
            url: '/auth/login',
            data: {
                email: this.$form.email.value,
                password: this.$form.password.value,
            },
            success: (response) => {
                if (!response.auth.token) {
                    throw new Error('Token missing from response.');
                }

                response.auth.logged_in = true;

                const remember_me = this.$form.remember_me.checked;

                store.setPersistence('auth', remember_me ? 'local': 'session');
                store.setPersistence('services', remember_me ? 'local': 'session');
                store.setPersistence('user', remember_me ? 'local': 'session');

                store.set('auth', response.auth);
                store.set('services', response.services);
                store.set('user', response.user);

                const urlParams = new URLSearchParams(window.location.search);
                const redirect = urlParams.get('redirect');

                if (redirect) {
                    window.history.pushState({}, "", redirect);
                } else {
                    window.history.pushState({}, "", "/dashboard");
                }

                window.dispatchEvent(new PopStateEvent('popstate'));
            },
            error: (response) => {
                store.clear('auth');
                store.clear('services');
                store.clear('user');

                display_errors(this.$errors, response, this.$form);

                this.$form.password.value = '';
                this.$submit.disabled = false;
                this.$submit.textContent = 'Log In';
            },
        });
    },
    _boundSubmit: null,

    onMount() {
        this.$form = document.getElementById('login-form');
        this.$errors = document.getElementById('LoginErrors');
        this.$submit = document.getElementById('LoginSubmit');

        const urlParams = new URLSearchParams(window.location.search);
        const redirect = urlParams.get('redirect');

        if (redirect) {
            const $register_link = document.getElementById('RegisterLink');
            if ($register_link) {
                $register_link.setAttribute('href', `/register?redirect=${encodeURIComponent(redirect)}`);
            }
        }

        this._boundSubmit = this.submit.bind(this);
        this.$form.addEventListener('submit', this._boundSubmit);
    },

    onUnmount() {
        if (this._boundSubmit) this.$form.removeEventListener('submit', this._boundSubmit);
    },
}
